import {
	Directive,
	TemplateRef,
	ViewContainerRef,
	OnInit,
	OnDestroy,
} from '@angular/core';
import { SubSink } from 'subsink';

// --- Facades ---
import { AuthFacade } from '@facades/auth.facade';

// --- Interfaces ---
import { EUserProfileIds } from '@interfaces/user';

@Directive({
	selector: '[appIsCustomer]',
})
export class IsCustomerDirective implements OnInit, OnDestroy {
	readonly authState$ = this.authFacade.authState$;
	private subs = new SubSink();

	constructor(
		private authFacade: AuthFacade,
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef
	) {}

	ngOnInit() {
		this.subs.add(
			this.authFacade.authState$.subscribe(user => {
				this.viewContainer.remove();
				if (
					user &&
					(user.user?.profileId === EUserProfileIds.CUSTOMER ||
						user.user?.profileId === EUserProfileIds.CUSTOMER_ADMIN)
				) {
					this.viewContainer.createEmbeddedView(this.templateRef);
				} else {
					this.viewContainer.clear();
				}
			})
		);
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}
}
